import { Option } from '@access-erp/common';

import {
  BillingIntervalType,
  BillingType,
  ClientDatabases,
  UsageHeaderStatus,
} from '../graphql/contracts/_generated_/contracts';
import { defaultBillingIntervalOptions } 
  from '@/components/common/EnquiriesScreen/utils/defaultFilterOptions.config';

export class DataMappers {
  static typesToOption(value: string): Option {
    return {
      label: value,
      value: value,
    };
  }

  static billingIntervalsToOptionsArray(billingIntervals?: BillingIntervalType[]) {
    if (!billingIntervals?.length) {
      return defaultBillingIntervalOptions;
    }

    const sortedArray = [...billingIntervals].sort((a, b) => a.monthsCount - b.monthsCount);
    return sortedArray.map((int) => DataMappers.typesToOption(int.formattedBillingInterval));
  }

  static clientDatabasesToOptionsArray(clientDatabases: ClientDatabases[]) {
    if (!clientDatabases?.length) {
      return [];
    }

    return clientDatabases.map((el) => ({
      label: el.name,
      value: el.iD,
    }));
  }

  static usageHeaderStatusesToOptionsArray(usageHeaderStatuses: UsageHeaderStatus[]) {
    return usageHeaderStatuses.map((el) => ({
      label: el.formattedStatus,
      value: el.status,
    }));
  }

  static billingTypesToOptionsArray(billingTypes: BillingType[]) {
    return billingTypes.map((el) => ({
      label: el.formattedType,
      value: el.type,
    }));
  }
}
